import type { FC } from 'react';
import React from 'react';

import useService from '@/lib/hooks/useService';

import CreateFeedbackForm from './CreateFeedbackForm';
import styles from './index.module.scss';

const CreateFeedbackModal: FC<{
  user: { id: string; name: string };
  houseNumber: string;
  onClose: () => void;
}> = (props) => {
  const [category] = useService({
    collectionName: 'categoryMenu',
    query: { service: 'feedback' },
  });

  const categoryOptions = category?.[0]?.data;

  if (!props.houseNumber || !categoryOptions) {
    return null;
  }
  return (
    <div className={styles.createFeedbackModal}>
      <h2 className={styles.title}>新增意見反應</h2>
      <CreateFeedbackForm {...props} feedbackTypes={categoryOptions} />
    </div>
  );
};

export default CreateFeedbackModal;
